<template>
  <div class="a-loading full">
    <button
      class="btn btn-borderless-secondary btn-lg"
      type="button"
      disabled
    >
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      />
      Now Loading...
    </button>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import "~@abeja-inc/abeja-ui-library/scss/_variables.scss";

$_LoadingContentWidth: 200px;
$_LoadingContentHeight: 200px;
$_LoadingContentMarginLeft: -$_LoadingContentWidth / 2;
$_LoadingContentMarginTop: -$_LoadingContentHeight / 2;
$_loadingSpinnerWidth: 100px;
$_loadingSpinnerHeight: 100px;
.a-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 300;
  width: $_LoadingContentWidth;
  height: $_LoadingContentHeight;
  margin-top: $_LoadingContentMarginTop;
  margin-left: $_LoadingContentMarginLeft;
  font-size: 56px;
  background-color: $blue-50;
  line-height: $_LoadingContentHeight;
  text-align: center;
  border-radius: 10px;
  box-shadow: $box-shadow;
}
</style>
